var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruckRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Truck Regular"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x8E\xA8 Color",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5013 11.25C11.8109 11.25 11.2513 10.6903 11.2513 9.99998V7.08331V4.58331H3.33464C3.10452 4.58331 2.91797 4.76986 2.91797 4.99998V13.0802C3.42834 12.2331 4.357 11.6666 5.41797 11.6666C6.73923 11.6666 7.85529 12.5452 8.21385 13.75H10.9554C11.314 12.5452 12.43 11.6666 13.7513 11.6666C15.0726 11.6666 16.1886 12.5452 16.5472 13.75H16.668C16.8981 13.75 17.0846 13.5634 17.0846 13.3333V11.25H12.5013ZM16.6384 15H16.668C17.5884 15 18.3346 14.2538 18.3346 13.3333V10.8333V10.8241C18.3346 10.6703 18.2921 10.5195 18.2117 10.3884L15.9057 6.62862C15.6027 6.13449 15.0647 5.83331 14.485 5.83331H12.5013V4.16665C12.5013 3.70641 12.1282 3.33331 11.668 3.33331H3.33464C2.41416 3.33331 1.66797 4.07951 1.66797 4.99998V13.3333C1.66797 13.9529 2.00609 14.4936 2.50788 14.7808C2.60942 16.2995 3.87351 17.5 5.41797 17.5C6.88733 17.5 8.10292 16.4134 8.3051 15H10.8642C11.0664 16.4134 12.2819 17.5 13.7513 17.5C15.2207 17.5 16.4363 16.4134 16.6384 15ZM12.5013 9.99998H16.5071L14.8402 7.28214C14.7644 7.15861 14.6299 7.08331 14.485 7.08331H12.5013V9.99998ZM5.41797 16.25C6.33844 16.25 7.08464 15.5038 7.08464 14.5833C7.08464 13.6628 6.33844 12.9166 5.41797 12.9166C4.49749 12.9166 3.7513 13.6628 3.7513 14.5833C3.7513 15.5038 4.49749 16.25 5.41797 16.25ZM13.7513 16.25C14.6718 16.25 15.418 15.5038 15.418 14.5833C15.418 13.6628 14.6718 12.9166 13.7513 12.9166C12.8308 12.9166 12.0846 13.6628 12.0846 14.5833C12.0846 15.5038 12.8308 16.25 13.7513 16.25Z",
    fill: "#9B9DAA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckRegular);
export default __webpack_public_path__ + "static/media/truck-regular.d7df6421345ecba83fd7f66903b45cc3.svg";
export { ForwardRef as ReactComponent };